import { h, Component, Fragment } from 'preact';

export default class ImportantInfoComponent extends Component {
    constructor() {
        super();
        this.state = {
            hasBeenOpened: false,
            isOpen: false
        };
    }

    getClass() {
        if (this.props.isOpen) {
            if (!this.state.hasBeenOpened) {
                this.setState({ hasBeenOpened: true });
            }
            return 'slide-panel-right-show';
        }
        else if (this.props.isOpen === false && this.state.hasBeenOpened) {
            return 'slide-panel-right-hide';
        }
        else {
            return '';
        }
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <aside class={`slide-panel--right ${self.getClass()}`}>

                    <button class="btn-close-important" onclick={self.props.close}>&times;</button>

                    <div class="slide-panel--inner">

                        <h2 class="font-light">Important Information</h2>

                        <div class="scroller" tabindex="0">
                            <p>
                                <strong>Strong earthquakes</strong> may cause tsunamis: If the shaking causes you to fall or have difficulty standing, protect yourself from the earthquake. When the shaking stops, leave the evacuation zone immediately.
                            </p>

                            <p>
                                <strong>Know the warning signs</strong>: As a tsunami approaches the shoreline, it could possibly expose the ocean floor, reef, and fish. You might see an approaching wall of water or hear a roar similar to that of a train or jet aircraft. If so, leave the evacuation zone immediately.
                            </p>

                            <p>
                                <strong> When a Tsunami Watch is issued</strong>, local officials will begin to plan for response and evacuations. You should also begin to prepare by finding out if you are currently in the evacuation zone and begin to contact family and loved ones.
                            </p>

                            <p>
                                <strong>When a Tsunami Advisory is issued</strong>, there will be no coastal evacuations; however officials will evacuate the ocean and beaches. Stay out of the ocean and away from beaches, and stay out of any canals or streams that feed directly from the ocean.
                            </p>

                            <p>
                                <strong>Outdoor warning sirens</strong> are activated by your local emergency management or county civil defense agency to notify the public of potential hazards. When you hear a siren, turn on the nearest radio or television and listen for emergency information and instructions.
                            </p>

                            <p>
                                <strong>Remain at least 100 feet away</strong> from inland waterways and marinas connected to the ocean because of wave surges and possible flooding.
                            </p>

                            <p>
                                <strong>For all Tsunami Warnings</strong>, evacuate out of the red zone. In the unlikely case of an "Extreme Tsunami Warning" (applicable in Hawai'i only), evacuate out of the red and yellow zones.
                            </p>

                            <p>
                                <strong>Boaters</strong> should move vessels to at least 50 fathoms (300 ft) deep and 2 nautical miles away from harbor entrances; follow all directions from the Captain of the Port.
                            </p>

                            <p>
                                <strong>Structural steel or reinforced concrete</strong> buildings of ten or more stories provide increased protection on or above the fourth floor; if you are caught near the shoreline consider using vertical evacuation.
                            </p>

                            <p>
                                <strong>The evacuation zone</strong> is a guideline and should be considered the minimum safe evacuation distance.
                            </p>

                            <p>
                                <strong>These maps do not</strong> consider the destructive effects of a locally generated tsunami. If you feel shaking, move inland immediately, well inland from the red tsunami evacuation zone.
                            </p>

                        </div>{/* scroll */}

                        <div class="box">
                            <h3 class="font-light"><center>For real-time information visit</center></h3>
                            <p>
                                <center>
                                    <a href="https://www.tsunami.gov/" target="_blank" rel="noreferrer">NOAA Tsunami Warning Center</a>
                                </center>
                            </p>
                        </div>

                    </div>{/* slide panel inner */}

                </aside>
            </Fragment>
        );
    }
}
